// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"7253":"1a7d4a48ff2984fd6e01","8278":"13d5a019874d7c825800"}[chunkId] + ".css";
};